// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__15uww","inputWrap":"CustomTip_inputWrap__3ITlg"};